import { PropertyChangeEvent } from "@otto-ec/otto-components-utils/use/property-change"
import { DataContainer, tracking } from "@otto-ec/tracking-bct"

export interface PasswordFieldTrackingProps {
    showPasswordTrackingEvent: DataContainer
    hidePasswordTrackingEvent: DataContainer
    trackOn: HTMLOcAuthFieldV1Element[] | HTMLOcAuthFieldV1Element
}

export function trackClickShowHidePasswordToggle(props: PasswordFieldTrackingProps) {
    let lastTrackedState: boolean | undefined = undefined
    const trackUserActivity = (event: DataContainer)=> {
        tracking.submitEvent(event).catch((e: unknown) => {
            console.error(e)
        })
    }
    const onClickShowHidePasswordToggle = (event: PropertyChangeEvent) => {
        if (!event.detail.passwordVisible) {
            return
        }

        /*                                                                                                 */
        /*                                                                                                */
        const newValue = event.detail.passwordVisible.current as boolean
        if (lastTrackedState !== newValue) {
            if (newValue) {
                trackUserActivity(props.showPasswordTrackingEvent)
            } else {
                trackUserActivity(props.hidePasswordTrackingEvent)
            }
            lastTrackedState = newValue
        }
    }
    const passwordFields = Array.isArray(props.trackOn) ? props.trackOn : [props.trackOn]
    passwordFields.forEach((passwordField) => {
        passwordField.addEventListener("oc-property-change", onClickShowHidePasswordToggle)
    })
}
